import { render, staticRenderFns } from "./SystemComponentsHierarchyCards.vue?vue&type=template&id=a3709486&"
import script from "./SystemComponentsHierarchyCards.vue?vue&type=script&lang=js&"
export * from "./SystemComponentsHierarchyCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports